import React, { useEffect } from "react";
import style from "./Chance.module.css";
import ShareBox from "../../components/shareButton/ShareBox";
import Button from "../../components/button/Button";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { configAction } from "../../store/config/slice";
import { GameStep } from "../../types/config";
import Header from "../../components/header/Header";
import FooterCo from "../../components/footer/FooterCo";
import GameChanceCard from "../../components/GameChanceCard/GameChanceCard";
import SpecialChanceBoard from "../../components/SpecialChanceBoard/SpecialChanceBoard";
import { updateUrlParams } from "../../helpers/url";
import useWebEngageMyGiftClick from "../../hooks/webengage/useWebEngageMyGiftClick";
interface shareProp {
  className?: string;
}
const ChancePage: React.FC<shareProp> = ({ className }) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.login.user.data?.data?.user);
  const userChance = useAppSelector((state) => state.game.chnace);
  const userSpecialChance = useAppSelector(
    (state) => state.game.special_chance
  );
  const { trackWebEngageMyGiftClick } = useWebEngageMyGiftClick();

  // oio
  useEffect(() => {
    window.addEventListener("popstate", () => {
      window.history.pushState({}, "", "?");
      dispatch(configAction.setGameStep(GameStep.HOME));
    });
  }, []);

  const handleBack = function () {
    window.history.pushState({}, "", "?");
    dispatch(configAction.setGameStep(GameStep.HOME));
  };

  return (
    <div className={style.chancePage}>
      <Header onBack={handleBack} title="دعوت از دوستان و دریافت شانس" />
      <div className={`${style.share} fade-in ${className ? className : ""}`}>
        <div className={style["expire-state"]}>
          <div className={style["expire-title"]}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/icon/gift.svg`}
              alt=""
            />
            <span>جوایزی که بردی رو اینجا ببین:</span>
          </div>
          <Button
            text="جوایز من"
            onclick={() => {
              dispatch(configAction.setGameStep(GameStep.BANIBON));
              trackWebEngageMyGiftClick();
            }}
            outlline
            className={style["move-tobanibon"]}
          />
        </div>
        <div className={style["required-chance-text-container"]}>
          <div className={style.line} />

          <span
            style={{
              color: "#FCFAEE",
              fontSize: 14,
              fontWeight: 325,
            }}
          >
            چرخوندن گردونه نیاز به یکی از شانس‌های زیر داره:
          </span>
          <div className={style.line} />
        </div>

        <div className={style["game-chance-card-container"]}>
          <GameChanceCard
            title="شانس بازی"
            description="برای دریافت کد تخفیف برندها"
            chance={userChance}
            onClick={() => {
              if (userChance && userChance > 0) {
                dispatch(configAction.setGameStep(GameStep.CATEGORY));
              } else {
                setTimeout(() => {
                  window.scrollTo({
                    top: document.body.scrollHeight,
                    behavior: "smooth",
                  });
                }, 100);
              }
            }}
            icon="red-heart"
          />
          <GameChanceCard
            title="شانس ویژه"
            description="برای دریافت جوایز ویژه"
            chance={userSpecialChance}
            onClick={() => {
              dispatch(configAction.setGameStep(GameStep.GAME));
              updateUrlParams({ category: "is_special" });
            }}
            icon="gold-heart"
          />
        </div>

        <div className={style["share-box"]}>
          <ShareBox id={user?.refId!} />
        </div>
        <div className={style["chance-daily-text-container"]}>
          <p>3 شانس بازی هر روز ساعت 10 صبح به شانس‌هات اضافه می‌شه.</p>
        </div>
        <ul className={style["invite-friends-list-container"]}>
          <li>
            با دعوت از هر دوست غیربانی‌مدی 5 شانس بازی و 5 شانس ویژه دریافت
            می‌کنی.
          </li>
          <li>
            با دعوت از هر دوست بانی‌مدی 2 شانس بازی و 2 شانس ویژه دریافت می‌کنی.
          </li>
        </ul>
        <SpecialChanceBoard />
        <div className={style.rule}>
          <div className={style["rule-icon"]}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/icon/alert-gold.svg`}
              alt=""
            />
          </div>
          <div>
            <p>
              دوست بانی‌مدی کسیه که قبلا عضو بانی‌مد شده و دوست غیربانی‌مدی کسیه
              که عضو بانی‌مد نبوده و از طریق لینک دعوت تو به خانواده بانی‌مد
              ملحق می‌شه.
            </p>
          </div>
        </div>
      </div>
      <FooterCo />
    </div>
  );
};

export default ChancePage;
